/**
 * Strip what makes untrusted text act on its reader instead of being read:
 * terminal escape sequences (CSI, terminated OSC, other ESC), C0/C1 controls
 * except tab and newline, bidi and zero-width characters that make text read
 * differently to a person than to a model, and Unicode tag characters, which
 * hide ASCII a model reads and a person cannot see.
 *
 * Customer text reaches a terminal through the CLI and a coding agent through
 * copied prompts; an `ESC[201~` in a Playwright error could end a bracketed
 * paste early and turn the rest of a prompt into keystrokes.
 */
const CONTROL_CHARACTERS = new RegExp(
  [
    // CSI, OSC with its terminator, and two-byte escapes. An unterminated OSC
    // falls to the two-byte branch: it loses its `ESC ]` introducer, not the
    // rest of the text.
    '\\u001b(?:\\[[0-?]*[ -/]*[@-~]|\\][^\\u0007\\u001b]*(?:\\u0007|\\u001b\\\\)|[@-Z\\\\-_])',
    // C0 except tab/newline, DEL and C1.
    '[\\u0000-\\u0008\\u000b-\\u001f\\u007f-\\u009f]',
    // Soft hyphen, Arabic letter mark, Mongolian vowel separator.
    '[\\u00ad\\u061c\\u180e]',
    // Zero-width space/joiners and LRM/RLM; bidi embeddings and overrides;
    // word joiner, invisible operators and isolates; BOM.
    '[\\u200b-\\u200f\\u202a-\\u202e\\u2060-\\u2064\\u2066-\\u2069\\ufeff]',
    // Tag characters U+E0000–E007F (surrogate pairs; the regex has no `u` flag).
    '\\udb40[\\udc00-\\udc7f]',
  ].join('|'),
  'g'
);

export function stripControlCharacters(value: string): string {
  return value.replace(CONTROL_CHARACTERS, '');
}
